import {Component} from '@angular/core';
import {ModalService} from "../../../../services/modal.service";

@Component({
  selector: 'app-delete-paylink-success-dialog',
  templateUrl: './delete-paylink-success-dialog.component.html',
  styleUrls: ['./delete-paylink-success-dialog.component.scss']
})
export class DeletePaylinkSuccessDialogComponent {

  constructor(
    private modalService: ModalService
  ) {
  }

  closeModal() {
    this.modalService.closeModal()
  }
}
